"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withBasedRouter = _interopRequireDefault(require("@devsta/with-based-router"));

var _commonReact = require("@devsta/common-react");

var _VideoReviewRoot = _interopRequireDefault(require("../components/VideoReviewRoot"));

var _api = require("../api");

var _basePath = _interopRequireDefault(require("../../../common/constants/basePath"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function VideoReview(_ref) {
  var history = _ref.history,
      _ref$match$params = _ref.match.params,
      videoId = _ref$match$params.videoId,
      outputId = _ref$match$params.outputId;
  var _history$location = history.location;
  _history$location = _history$location === void 0 ? {} : _history$location;
  var hash = _history$location.hash;
  var selectedVersion = hash.slice(1);
  return /*#__PURE__*/_react.default.createElement(_commonReact.CollaborationProvider, {
    resourceId: videoId,
    resourceName: "Video"
  }, /*#__PURE__*/_react.default.createElement(_commonReact.RequestProvider, {
    requests: {
      getVideo: (0, _api.getVideo)(videoId),
      approveOutput: (0, _api.approveOutput)(outputId),
      getOutputNextStatus: (0, _api.getOutputNextStatus)(outputId),
      getOutputStatuses: (0, _api.getOutputStatuses)(),
      requestOutputChanges: (0, _api.requestChanges)(outputId),
      updateRequestedAddons: (0, _api.updateRequestedAddons)(),
      updateAddonStatus: (0, _api.updateAddonStatus)(),
      requestApproval: (0, _api.requestApproval)(outputId)
    }
  }, function (requests) {
    return /*#__PURE__*/_react.default.createElement(_commonReact.UploaderConsumer, null, function (_ref2) {
      var fetchAssets = _ref2.fetchAssets;
      return /*#__PURE__*/_react.default.createElement(_commonReact.CollaborationConsumer, null, function (_ref3) {
        var fetchCollaborationData = _ref3.fetchCollaborationData;
        return /*#__PURE__*/_react.default.createElement(_commonReact.AuthorisationConsumer, null, function (_ref4) {
          var permissions = _ref4.selectedOrganisation.permissions;
          return /*#__PURE__*/_react.default.createElement(_commonReact.AddonsProvider, {
            loaderProps: {
              darkTheme: false
            }
          }, /*#__PURE__*/_react.default.createElement(_VideoReviewRoot.default, _extends({
            videoId: videoId,
            outputId: outputId,
            history: history,
            fetchAssets: fetchAssets,
            fetchCollaborationData: fetchCollaborationData,
            selectedVersion: parseInt(selectedVersion, 10),
            orgPermissions: permissions
          }, requests)));
        });
      });
    });
  }));
}

var _default = (0, _withBasedRouter.default)(_basePath.default, VideoReview);

exports.default = _default;